import { Directive, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { isBrowser } from 'angular2-universal';
import { Location } from '@angular/common';
import { UtilsService } from './utils.service';
import { ConfigService } from './config.service';
import { CookieService } from 'angular2-cookie/core';
//import { isBrowser } from 'angular2-universal';

@Directive({
    selector: '[lg-routing]',
    exportAs: 'lgRouting',
})
export class LanguageRoutingComponent implements OnInit {

    public resourcePath: string;
    public currentLanguage: string;
    private isRoot: boolean;
    
    constructor(private config: ConfigService, private location: Location, private router: Router, private utils: UtilsService, private cookieService: CookieService) {
    }

    onSelect(langSelect: string) {
        this.currentLanguage = langSelect;
        //console.log('[lang]', this.currentLanguage, '(select)');
    }

    isRootUrl(){
        if(this.location.path()=='/'||this.location.path()=='')
            return true;
        return false;
    }

    // Set some properties based on the current URL
    // Navigate based on existing cookie if no current current language is available in the URL
    ngOnInit() {

        this.isRoot = this.isRootUrl();

        // Need to wait until router has finished so as to get the current path
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {

        // Get resource URL without language
        this.resourcePath = this.utils.getLanguageAgnosticUrl(this.location.path()); // without the base href

        if(!this.currentLanguage){
            // Current language retrieved from URL by default
            this.currentLanguage = this.utils.getLanguageByUrl(this.location.path());
            if(this.currentLanguage){
                //console.log('[lang]', this.currentLanguage, '(url)');
            } else {
                // Language cookie not working with SSR
                // But handled when the browser kicks in: picks up the cookie and navigate with the language in the uRL
                // This is when SSR is able to render the page in the right language although the server side did not pick up the language
                let langCookie = null;
                
                if(isBrowser){
                    langCookie = this.cookieService.get('lang');
                    if (langCookie) {
                        this.currentLanguage = langCookie;
                        let target = this.resourcePath;
                        if(!this.config.data.APP.LANGUAGES.SQUASH || langCookie != this.config.data.APP.LANGUAGES.PREFERRED){
                            target = langCookie + target;
                            this.router.navigateByUrl(target);
                        }
                        //console.log('[lang]', this.currentLanguage, '(cookie)');
                    }
                }
                if(!langCookie){
                    this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
                    let target = this.resourcePath;
                    if(!this.config.data.APP.LANGUAGES.SQUASH){
                        target = this.config.data.APP.LANGUAGES.PREFERRED + target;
                        this.router.navigateByUrl(target);
                    }
                    //console.log('[lang]', this.currentLanguage, '(preferred)');
                }
            }
        }

        }})
    }
} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/language-routing.component.ts